var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    width: 36,
    height: 36,
    rx: 18,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.2145 16.6226L26.9161 9H25.3282L19.5066 15.6172L14.8602 9H9.5L16.5278 19.0073L9.5 27H11.0879L17.2319 20.0104L22.1398 27H27.5L20.2145 16.6226ZM18.039 19.0951L17.3258 18.098L11.6605 10.1713H14.0998L18.6732 16.5708L19.3834 17.5679L25.3275 25.8857H22.8882L18.039 19.0951Z",
    fill: "#0F1419"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.8cf2bf9f9230a145b2efb2361433993a.svg";
export { ForwardRef as ReactComponent };